import { Navbar, Nav, NavItem, NavDropdown, Form, FormControl, Button, Container } from 'react-bootstrap';


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function Navigation() {
    const alert = useSelector(state => state.alert);
    const loggedIn = useSelector(state => state.authentication.loggedIn);
    const authentication = useSelector(state => state.authentication);
    const user = useSelector(state => state.user);

    const version = localStorage.getItem('version') == null ? { "version": "0.0.0"} :  localStorage.getItem('version') ;
    //const version = Object.keys(user).length === 0  ? { "version": "0.0.0"} : user.version;


    console.log("authentication: " + authentication);

		return (
				<div>
				{ loggedIn &&  
                    <div className="navbar-default">
                       
                        <Navbar className="col-lg-12" bg="primary" variant="dark" expand="lg" sticky="top">
                            <Container fluid>
                                <Navbar.Brand href="#/applications"><img src='./images/nyse.png' /></Navbar.Brand>
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Collapse id="basic-navbar-nav" >
                                    <Nav className="mr-auto">
                                        <Nav.Link href="#/applications"><h5>Applications</h5></Nav.Link>
                                        
                                    </Nav>
                                    <Nav>
                                        <Navbar.Brand href="#/applications">EFP (Electronic Filing Platform)</Navbar.Brand>
                                        <NavDropdown title={ authentication.user.fullName } id="basic-nav-dropdown">
                                            <NavDropdown.Item href="#/personalinformation" >Personal Info</NavDropdown.Item>
                                            <NavDropdown.Item href="#/changepassword">Change Password</NavDropdown.Item>
                                            <NavDropdown.Divider />
                                            <NavDropdown.Item href="#/contactus">Contact Us</NavDropdown.Item>
                                            <NavDropdown.Item href="">{ version } </NavDropdown.Item>

                                        </NavDropdown>
                                        <Nav.Link href="#/login">Logout</Nav.Link>
                                    </Nav>
                                
                                </Navbar.Collapse>
                            </Container>                   
                        </Navbar>
                    </div>
                 }
            </div>
		);

};

export { Navigation };